import { convertToZonedTimestamp } from "common/helpers/dateAndTimeHelpersV2"
import { ConfigurableChart } from "../"

export const AxisChartDemos = (props): JSX.Element => {

  const {
    data,
    grouping_key,
    totals_key,
    count_key,
    timestamp_key,
    start_time,
    end_time
  } = props || {}

  const chart_settings = {
    data,
    start_time,
    end_time,
    timestamp_key: 'timestamp',
    chart_type: 'bar',
    color_key: 'group',
    color: {
      fish: 'green',
      steak: 'red',
      chicken: 'yellow'
    },
 scale_type: 'time',
 totals_key: 'weight',

 
  }
 
  return (
    <ConfigurableChart {...chart_settings} />
  )
}